import { EVM_CONFIG } from "../config";

/**
 * The relayer fee bound into a proof: the configured share of the amount,
 * never below the network's floor. Base has no floor (byte-identical to the
 * historical share); DogeOS Chikyu prices gas in DOGE and its relayer refuses
 * a settlement whose fee does not cover the reserved gas (plan D4), so the
 * floor keeps small withdrawals from being refused after proving.
 */
export function flatRelayFee(
  amount: bigint,
  config: {
    RELAY_FEE_BPS: number;
    RELAY_MIN_FEE_WEI?: bigint;
  } = EVM_CONFIG.JOINSPLIT_V2,
): bigint {
  const share = (amount * BigInt(config.RELAY_FEE_BPS)) / 10_000n;
  const floor = config.RELAY_MIN_FEE_WEI ?? 0n;
  return share > floor ? share : floor;
}
